import eventManager from "../../store/sqftEventManager";
import Config from "../../store/sqftConfig";
import workspace from "../workspace";
import Cursor from "./cursor";
import MiteredOverlay from "../shapes/overlays/mitered";
import {
  inchesToMm,
  measureDistanceToInches, mm2ToM2,
  mmToInches, sqInchesToSqFoot,
} from "../../../../helpers/sqftHelper";
import {iconPlusBlue} from "../../../../assetsSQFT";
import store from "../../../../../../store";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {
  EDGE_LABELS, MITERED_OVERLAY_TYPE,
  RESOURCE_ATTACHED_TO_TYPE, RESOURCE_TYPE,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_HIDDEN_BUTTONS,
} from "../../../../constants";
import {setSQFTMenuOpened, setSQFTMenuOpenedLock} from "../../../../../../actions/sqftMenuFunctions";
import {attachResource} from "./resourseCanas";
import {getEdgeFeatures} from "../../../../helpers/shapeHelper";
import {addResource, changeResource, deleteResource} from "../../../../../../actions/sqftResourceFunctions";
import {getUnderlaymentFeature} from "../../../../helpers/sqftHelperUi";
import sqftConfig from "../../store/sqftConfig";

export default class UnderlaymentController {
  cursor;
  design = {
    imgSrc: iconPlusBlue
  };
  miteredSections = [];

  createCursor = () => {
    this.cursor = new Cursor();
    this.cursor.setCursorImage(this.design.imgSrc);
    eventManager.setCursor('mitered-select', this, true);
  };

  registerEvents = () => {
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  onMouseUp = (mousePos) => {
    void mousePos;
    let hoverShape = workspace.getHoverShape();

    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton !== SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment) {
        return
      }

      let seg = hoverShape.getHoverSegment();
      if (seg && seg.isWithUnderlayment() && reduxState.sqftMenuState.activeButton === SIDEBAR_BUTTONS_MENU.delete) {
        seg.deleteMitered();
      } else if(seg && seg.isWithUnderlayment()) {
        void 0;
      } else if (seg && !seg.isWithUnderlayment() && !seg.isWithBumpout() && this.cursor.cursorImage) {
        attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.underlayment, null, null,'', 0, null, null, false);
      } else {
        // Menu.openMenu();
        // deregisterEvents();
        // elements.designDefault.click();
      }
    }

    //todo
    this.cursor.checkForRestoreCursor();
  };

  addSection = (miteredSection) => {
    const reduxState = store.getState();
    store.dispatch(addResource(RESOURCE_TYPE.underlaymentSections, miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment));
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };

  updateSection = (miteredSection) => {
    store.dispatch(changeResource(RESOURCE_TYPE.underlaymentSections, miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment));
    store.dispatch(setSQFTMenuOpenedLock(true));

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }

  deleteSection = (miteredOverlay) => {
    store.dispatch(deleteResource(RESOURCE_TYPE.underlaymentSections, miteredOverlay.id));
  };

  createUnderlaymentOverlay = (line) => {
    const reduxState = store.getState();
    const underlaymentSections = reduxState.sqftResourceState.underlaymentSections;
    const underlaymentOverlay = new MiteredOverlay(line, underlaymentSections.length + 1, MITERED_OVERLAY_TYPE.underlayment);
    const feature = getUnderlaymentFeature();
    if (feature) {
      underlaymentOverlay.setFeatureId(feature.part.dbFeature.id)
    }

    return underlaymentOverlay
  };

  destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    //this.hide();
  };

  deregisterEvents() {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    this.cursor ? this.cursor.deregisterEvents() : null;
    Config.highlight.lines = false;
  }

  static getTotalArea = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      miteredSectionsArea += miteredSections[i] ? miteredSections[i].getMiteredToolTotalArea() : null;
    }

    return miteredSectionsArea;
  };

  onMeasureUnitChange = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      let segments = miteredSections[i].getSegments();

      segments.map((segment) => {
        segment.height = Config.measureUnit === "Metric"
          ? inchesToMm(segment.height)
          : mmToInches(segment.height);
        if (segment.thickness) {
          segment.thickness.value = Config.measureUnit === "Metric"
            ? inchesToMm(segment.thickness.value)
            : mmToInches(segment.thickness.value)
        }
      });

      miteredSections[i].heightNumberText.value = segments[0].height
    }

    return miteredSectionsArea;
  };

  getTransformedMeasureUnit = (value) => {
    return Config.measureUnit === "Metric"
      ? measureDistanceToInches(value).millimeters // ? distanceToMillimeters(inchesToMm(segment.length.value))
      : value;
  };

  getEdgesLength = () => {
    let additionalLength = 0;
    const lines = workspace.getLines();
    for (const line of lines) {
      if (line.from.getMiteredFeatureId()) {
        additionalLength += this.getEdgeLengthValue();
      }
    }

    return additionalLength
  }

  getEdgeLengthValue = () => {
    return Config.measureUnit === "Imperial"
      ?  (2 * 33) / 40
      : (2 * 900) / 1000;
  }

  getExportedMiteredEdges = () => {
    let addedEdges = [];
    const lines = workspace.getLines();
    for (const line of lines) {
      const miteredFeatureId = line.from.getMiteredFeatureId();
      if (miteredFeatureId) {
        const edgeLengthValue = this.getEdgeLengthValue();
        const navItems = getEdgeFeatures();
        let edgeFeature = navItems.find(edge => edge.part.dbFeature.id === miteredFeatureId);

        addedEdges.push({
          partId: EDGE_LABELS.edge,
          type: EDGE_LABELS.edge,
          name: workspace.intl.formatMessage({id: edgeFeature.part.dbFeature.sharedFeatureName}),
          featureId: miteredFeatureId,
          segments: 1,
          length: edgeLengthValue,
          area: edgeLengthValue
        });
      }
    }

    return addedEdges
  }

  exportData = () => {
    const reduxState = store.getState();
    const underlaymentSections = reduxState.sqftResourceState.underlaymentSections;

    //return {quantity: underlaymentSections.reduce((acc, current) =>  acc + current.getMiteredToolTotalArea(), 0)};
    return {sections: underlaymentSections.map((section) => ({
        id: section.id,
        qtCatName: section.qtCatName,
        featureId: section.featureId,
        quantity: sqftConfig.measureUnit === "Imperial"
          ? Math.ceil10(sqInchesToSqFoot(section.getMiteredToolTotalArea()), -2)
          : mm2ToM2(section.getMiteredToolTotalArea())
      }))
    };
  }
}
